<template>
  <div>
    <b-container
      class="invite-wrapper"
      :key="invite.id"
      fluid
      v-for="invite in invites.results"
    >
      <b-container>
        <router-link :to="`/goodluck/${invite.id}/`">
          <div class="capsule-wrapper py-3 py-lg-0">
            <div
              class="capsule"
              :style="{ backgroundImage: `url(${invite.background})` }"
            >
              <img :src="invite.logo" class="logo" />
            </div>
            <div class="invite w-100">
              <b-row class="h-100">
                <b-col cols="12" lg="4" offset-lg="4">
                  <div
                    class="d-flex flex-column justify-content-center align-items-center h-100 w-100 overflow-hidden text-center"
                  >
                    <div class="title">
                      {{ invite.title }}
                    </div>
                    <div class="subtitle">
                      {{ invite.subtitle }}
                      <hr class="d-none d-lg-block" />
                    </div>
                    <div class="description">
                      {{ invite.description }}
                    </div>
                    <div
                      class="d-flex justify-content-center align-items-center w-100"
                    >
                      <div
                        class="status d-flex align-items-center font-weight-bold"
                        :class="invite.status"
                      >
                        {{ getStatus(invite) }}
                      </div>
                      <div class="date">
                        {{ getDate(invite) }}
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </router-link>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import * as moment from "moment";
import { Invite } from "../models";

export default {
  data() {
    return {
      moment: window.moment,
      user: window.user,
      invites: {
        results: []
      }
    };
  },
  async mounted() {
    this.invites = await new Invite().get({ limit: 100 });
  },
  methods: {
    getStatus(invite) {
      switch (invite.status) {
        case "review":
          return "Under review (검토중)";
        case "ongoing":
          return "진행중";
        case "examination":
          return "심사중";
        case "selection":
          return "선정";
      }

      return "";
    },
    getDate(invite) {
      moment.locale("ko");

      switch (invite.status) {
        case "ongoing":
          return moment(invite.closed).fromNow(true) + "남음";
        case "examination":
          return "잠시만 기다려주세요.";
        case "selection":
          return moment(invite.selected).format("LL");
      }

      return "";
    },
    setHover(invite, hover) {
      this.$set(invite, "hover", hover);
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes animation {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

a {
  color: inherit;
}

.invite-wrapper {
  margin-bottom: 60px;
  background-color: #f7f7f7;

  &:last-child {
    margin-bottom: 200px;
  }

  .capsule-wrapper {
    position: relative;

    @media (min-width: 992px) {
      overflow: hidden;
      height: 450px;
      border-radius: 260px;
    }

    .capsule {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 260px;
      background-size: cover;
      background-position: center;

      @media (min-width: 992px) {
        position: absolute;
        justify-content: center;
        align-items: center;
        height: 450px;
        border-radius: 260px;
      }

      .logo {
        width: 240px;
      }
    }

    .invite {
      @media (min-width: 992px) {
        position: absolute;
        opacity: 0;
        height: 450px;
        background-color: white;

        &:hover {
          animation-name: animation;
          animation-duration: 0.5s;
          animation-fill-mode: forwards;
        }
      }

      .title {
        width: 100%;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .subtitle {
        width: 100%;
        font-size: 13px;
        font-weight: bold;
      }

      hr {
        margin: 24px 0;
      }

      .description {
        overflow: hidden;
        max-height: 130px;
        margin-bottom: 35px;
        text-align: left;
      }

      .status {
        margin-right: 10px;

        &:before {
          content: "";
          display: inline-block;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: red;
          margin-right: 5px;
        }
      }

      .status.ongoing:before {
        background-color: #00ff00;
      }

      .status.examination:before {
        background-color: #fff000;
      }
    }
  }
}
</style>
